// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6545":"58549949","7403":"58549949"}[chunkId] + ".chunk.css";
};